<template>
    <option value="">{{ $t('seleziona-un-setore') }}</option>
    <option value="agricoltura">{{ $t('agricoltura-industria-alimentare') }}</option>
    <option value="artigianato">{{ $t('artigianato-commercio') }}</option>
    <option value="assicurazioni">{{ $t('assicurazioni') }}</option>
    <option value="automobilistico">{{ $t('automobilistico') }}</option>
    <option value="benestare">{{ $t('benestare-assistenza-sociale') }}</option>
    <option value="chimicaFarmaceutica">{{ $t('chimica-farmaceutica-biotecnologia-tecnologia-medica') }}</option>
    <option value="costruzioni">{{ $t('costruzioni-architettura') }}</option>
    <option value="consulenza">{{ $t('consulenza-legale') }}</option>
    <option value="educazione">{{ $t('educazione') }}</option>
    <option value="elettronicaIngegneria">{{ $t('elettronica-ingegneria-meccanica') }}</option>
    <option value="energia">{{ $t('energia') }}</option>
    <option value="finanzaBancario">{{ $t('finanza-bancario') }}</option>
    <option value="governo">{{ $t('governo-pubblica-amministrazione') }}</option>
    <option value="immobiliare">{{ $t('immobilare') }}</option>
    <option value="industriaSicurezza">{{ $t('industria-della-sicurezza-e-del-salvataggio') }}</option>
    <option value="ingegneria">{{ $t('ingegneria') }}</option>
    <option value="istruzione">{{ $t('istruzione') }}</option>
    <option value="marketing">{{ $t('marketing-comunicazioni') }}</option>
    <option value="mediaIntrattenimento">{{ $t('media-e-intrattenimento') }}</option>
    <option value="produzioneIndustria">{{ $t('produzione-industria') }}</option>
    <option value="recruitment">{{ $t('recruitment-hr') }}</option>
    <option value="ristorazioneTurismo">{{ $t('ristorazione-e-hotel-turismo') }}</option>
    <option value="sanita">{{ $t('sanita') }}</option>
    <option value="serviziPubblici">{{ $t('servizi-pubblici-associazioni-autorita') }}</option>
    <option value="sportTempoLibero">{{ $t('sport-e-tempo-libero') }}</option>
    <option value="tecnologiaInformatica">{{ $t('tecnologia-informatica') }}</option>
    <option value="telecomunicazioni">{{ $t('telecomunicazioni') }}</option>
    <option value="trasportiLogistica">{{ $t('trasporti-e-logistica') }}</option>
    <option value="venditaDettaglio">{{ $t('vendita-al-dettaglio') }}</option>
    <option value="altro">{{ $t('altri-specificare') }}</option>
</template>

<script>
    export default {
        name: 'SelectOptions',
    };
</script>
